export function createInterviewsList(interviews) {
  if (!interviews || !Array.isArray(interviews) || interviews.length === 0) {
    return null;
  }

  const section = document.createElement('div');
  section.className = 'interviews-section';
  section.style.marginTop = 'var(--space-xl)';

  section.innerHTML = `
    <div class="section-header">
      <h2 class="section-title">Interviews & Coverage</h2>
    </div>
    <div style="display: flex; flex-direction: column; gap: var(--space-xs);">
      ${interviews.map(item => `
        <a href="${item.url}" target="_blank" rel="noopener noreferrer" class="song-card clickable-item" style="padding: 10px 14px;">
          <div class="song-icon" style="width: 36px; height: 36px;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          </div>
          <div class="song-info">
            <h4 class="song-title" style="font-size: 0.9rem;">${item.title}</h4>
            <span class="song-artists">${item.media}</span>
          </div>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
        </a>
      `).join('')}
    </div>
  `;

  return section;
}
